/* eslint-disable radix */
import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';

const GuestGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  // Allow member verification without authentication
  if (location.pathname === '/member-verification') {
    return <>{children}</>;
  }

  // Handle authenticated users
  if (isAuthenticated && !!user) {
    if (user?.userType === "company") {
      return <Redirect to="/company" />;
    }
    if (user?.userType === "member") {
      return <Redirect to="/member" />;
    }
    return <Redirect to="/dashboard" />;
  }

  return (
    <>
      {!isAuthenticated && children}
    </>
  );
};

GuestGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GuestGuard;
